// extracted by mini-css-extract-plugin
export const hotkey = "styles-module--hotkey--6TTWW";
export const detail = "styles-module--detail--3G5VF";